'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { useFplPlayerSearch } from '@/lib/api/fpl-routes'
import { Spinner } from '@/components/ui/spinner'
import { pinScrollOnFocus } from '@/lib/utils'

export function FplPlayersPage() {
  const [query, setQuery] = useState('')
  const router = useRouter()

  const { data, isLoading, isFetching } = useFplPlayerSearch(query)
  const results = data?.data ?? []

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center gap-4 py-6 text-center">
      <h2 className="text-xl font-semibold text-white">Search for an FPL player</h2>

      <div className="w-full max-w-sm">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={pinScrollOnFocus}
          placeholder="Search by player name…"
          className="w-full rounded-md border border-white/10 bg-black px-3 py-2 text-center text-sm text-white outline-none placeholder:text-white/30 focus:border-white/30"
        />
      </div>

      {query.trim().length >= 2 && (isLoading || isFetching) && (
        <div className="flex justify-center py-4">
          <Spinner className="size-5 text-white/50" />
        </div>
      )}

      {query.trim().length >= 2 && !isLoading && results.length === 0 && (
        <p className="text-sm text-white/40">No players found.</p>
      )}

      {results.length > 0 && (
        <div className="w-full max-w-sm rounded-xl border border-white/10 bg-[#0e1114] text-left">
          {results.map((r, i) => (
            <button
              key={r.fpl_id}
              type="button"
              onClick={() => router.push(`/fpl/players/${r.fpl_id}`)}
              style={{ animationDelay: `${i * 30}ms`, animationFillMode: 'backwards' }}
              className="flex w-full animate-in items-center gap-3 border-b border-white/10 px-3 py-2 text-left fade-in-0 slide-in-from-bottom-1 transition-colors duration-200 ease-out last:border-b-0 hover:bg-white/5"
            >
              <span className="flex size-6 shrink-0 items-center justify-center">
                {r.team_logo_url ? (
                  <img src={r.team_logo_url} alt="" className="size-6 object-contain" />
                ) : (
                  <div className="size-6 rounded-full bg-white/10" />
                )}
              </span>
              <span className="truncate text-sm text-white">{r.display_name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
